import { kpiApi } from "@/api/kpiApi";
import { Box, Button, Collapse, Divider, Paper, Stack, Typography, Card, CardHeader, CardContent } from "@mui/material";
import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { AddNewSegmentForm } from "./AddNewSegmentForm";
import { Segment } from "./Segment";

export default function KpiSettingSegment() {
    const [formOpen, setFormOpen] = useState(false);
    const { kpi } = useOutletContext();
    const kpiData = kpi?.data?.data;
    const kpiSegments = kpiData?.kpi_data_segments?.filter((x) => x.primary == true) ?? [];

    const [createSegment] = kpiApi.endpoints.createNewKpiDataSegment.useMutation();
    const [updateSegment] = kpiApi.endpoints.updateKpiDataSegment.useMutation();
    const [deleteSegment] = kpiApi.endpoints.deleteKpiDataSegment.useMutation();

    const handleAddNewSegment = (kpiId, values) => {
        return createSegment({ kpiId, data: values });
    };
    const handleUpdateSegment = (kpiId, segmentId, values) => {
        return updateSegment({
            kpiId,
            kpiDataSegmentId: segmentId,
            data: values,
        });
    };
    const handleDeleteSegment = (kpiId, segmentId) => {
        return deleteSegment({ kpiId, kpiDataSegmentId: segmentId });
    };

    return (
        <Card variant="outlined">
            <CardHeader
                title={`Segment (${kpiSegments.length ?? "-"})`}
                action={
                    <Button variant="outlined" onClick={() => setFormOpen((prev) => !prev)}>
                        Add
                    </Button>
                }
            ></CardHeader>
            <Divider variant="middle" />
            <CardContent>
                <Collapse in={formOpen}>
                    <Box sx={{ marginBottom: 2 }}>
                        <AddNewSegmentForm
                            kpi={kpi}
                            handleAddNewSegment={handleAddNewSegment}
                            handleOnCloseForm={() => setFormOpen(false)}
                        />
                    </Box>
                </Collapse>

                <Stack divider={<Divider />}>
                    {kpiSegments?.map((segment) => (
                        <Segment
                            key={segment.id}
                            segment={segment}
                            handleUpdateSegment={handleUpdateSegment}
                            handleDeleteSegment={handleDeleteSegment}
                        />
                    ))}
                </Stack>
            </CardContent>
        </Card>
    );
}
